import { axiosInstance } from '../../api';
const BASE_PATH = '/reference_check';

//Get All Reference Checks API Call
export let getReferenceChecksCards = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_reference_checks');
        return value;
    } catch (error) {
        return error
    }
}

//Get All Reference Checks by group API Call
export let getAllReferenceCheckGroupDetails = async (step_id, reference_check_state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_assigned_reference_checks_by_group', {
            step_id: step_id,
            reference_check_state: reference_check_state
        });
        return value;
    } catch (error) {
        return error
    }
}


//Get Single Reference Check Task Details API Call
export let getReferenceCheckTask = async (sessionID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_reference_check_task', {
            session_id: sessionID
        })
        return value;
    } catch (error) {
        return error
    }
}

//Submit and Pass Reference Check Task Details API Call
export let submitReferenceCheckTask = async (sessionID) => {

    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_reference_check', {
            session_id: sessionID,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Save Reference Check Task Details API Call
export let saveReferenceDetails = async (sessionID, referenceDetails, referenceFeedback, index, state) => {

    try {
        let value = await axiosInstance.post(BASE_PATH + '/save_reference_details', {
            session_id: sessionID,
            reference_feedback: referenceFeedback,
            index: index,
            reference_details: referenceDetails,
            state: state

        })
        return value;
    } catch (error) {
        return error
    }
}

//Reject Reference Check API Call
export let rejectReferenceCheckTask = async (sessionID, rejectReason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reject_reference_check',{
            session_id: sessionID,
            reject_reason: rejectReason,
        });
        return value;
    } catch (error) {
        return error
    }
}